var render = function (_h,_vm) {var _c=_vm._c;return _c('b-loading',{attrs:{"active":""}})}
var staticRenderFns = []

export { render, staticRenderFns }